import {Colors} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const TemplateVariableFormLayout = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${Colors.GRAY_300};
  border-radius: 4px;
  padding: 12px;
  min-width: 250px;
`;

export const VariableName = styled.div`
  display: flex;
  flex-direction: row;
`;

export const VariableNameText = styled.div`
  display: flex;
  font-size: 14px;
  font-family: 'Source Code Pro', monospace;
  font-weight: 600;
  color: ${Colors.SIENNA};
  background: ${Colors.GRAY_50};
  border-radius: 4px;
  padding: 0px 4px;
  flex-shrink: 0;
  height: 24px;
`;

export const VariableNameFiller = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const VariableFormField = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  padding: 4px 0px;
  margin-right: 4px;
`;

export const VariableFormFieldNote = styled.div`
  color: ${Colors.GRAY_500};
  font-size: 14px;
  padding: 4px 0px;
  font-weight: 400;
  line-height: 32px;
`;

export const VariableFormFieldRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
`;

export const MinMaxWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MinMaxInnerSeparator = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 8px;
`;
